module.exports = __webpack_public_path__ + "img/main.968bae88.jpeg";